import mobx, { observable, action, computed } from 'mobx';
import { replaceAll } from '../common';

export class DictStore {

  @observable lang = '';
	@observable dict = {};
  // reg_exp_ru = new RegExp('[[А-Яа-я]+');
  data = {};

  add(data) {
      for (const i in data) {
          this.dict[i] = data[i];
      }
  }

  @action getLang(key, replace) {
      let lang = '';
      if (!key) { return key; }
      else if (this && this.dict && this.dict[key]) {
          lang = this.dict[key];
      }
      else if (window.dict_data && window.dict_data[key]) {
          lang = window.dict_data[key];
      }
      else if (new RegExp('[[А-Яа-я]+').test(key) === false) {
          lang = key.toString().toLowerCase().split('_').join(' ');
          if (lang.length) {
              lang = lang[0].toUpperCase() + lang.substr(1);
          }
      } else {
          lang = key;
      }

      if (replace) {
          lang = this.replace(lang, replace);
      }

      return lang;
  }

  replace(text, opts) {
      for (const i in opts) {
          text = replaceAll('{' + i + '}', opts[i], text);
          //text = text.replace('{' + i + '}', opts[i]);
      }

      return text;
  }

  addDict(data) {
      if (!data) { return; }
      if (data.dict) {
          for (const i in data.dict) {
              if (!this.data[i]) {
                  this.data[i] = {};
              }
              for (const j in data.dict[i]) {
                  this.data[i][j] = data.dict[i][j];
              }
          }
      }
  }

  getBy(subject, key) {
      if (this.data) {
          if (this.data[subject]) {
              if (this.data[subject][key]) {
                  return this.data[subject][key];
              }
          }
      }

      return '';
  }
}

export default new DictStore();


// WEBPACK FOOTER //
// ./src/stores/dictStore.js